var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-about"},[_c('Section1'),_c('Section2'),_c('Section4')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }